import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';

const GlobalBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Show only on paths that are not home and not admin/seller panels
  if (
    location.pathname === '/' || 
    location.pathname.startsWith('/admin') || 
    location.pathname.startsWith('/seller') ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/register')
  ) {
    return null;
  }

  return (
    <motion.div 
      initial={{ opacity: 0, y: -10 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.3 }}
      style={{ width: '100%', maxWidth: 1920, padding: '0 20px', margin: '0 auto', marginBottom: 16 }}
    >
      <Button 
        type="default" 
        icon={<HomeOutlined />} 
        onClick={() => navigate('/')}
        shape="round"
        size="large"
        style={{ fontWeight: 600, display: 'inline-flex', alignItems: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.05)', backgroundColor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(8px)', border: '1px solid rgba(0,0,0,0.1)', color: '#334155' }}
      >
        Bosh sahifaga qaytish
      </Button>
    </motion.div>
  );
};

export default GlobalBackButton;
